/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type MenuCollectionProductFragment = {
  readonly __typename?: 'Product';
  readonly id: string;
  readonly slug: string;
  readonly name: string;
  readonly description: string;
  readonly calories: number;
  readonly cost: number;
  readonly outOfStock: boolean;
  readonly restaurantId: string;
  readonly label: {
    readonly __typename?: 'ProductLabel';
    readonly id: string;
    readonly name: string;
  } | null;
  readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
  readonly dietaryProperties: ReadonlyArray<{
    readonly __typename?: 'DietaryProperty';
    readonly id: string;
    readonly name: Types.DietaryPropertyKind;
  }>;
  readonly ingredients: ReadonlyArray<{
    readonly __typename?: 'Ingredient';
    readonly id: string;
    readonly name: string;
  }>;
};

export type MenuCollectionQueryVariables = Types.Exact<{
  collectionId: Types.Scalars['ID']['input'];
}>;

export type MenuCollectionQuery = {
  readonly __typename?: 'Query';
  readonly menuCollection: {
    readonly __typename?: 'MenuCollection';
    readonly id: string;
    readonly color: string;
    readonly primaryImageUrl: string;
    readonly primaryTitle: string;
    readonly primaryDescription: string;
    readonly products: ReadonlyArray<{
      readonly __typename?: 'Product';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly description: string;
      readonly calories: number;
      readonly cost: number;
      readonly outOfStock: boolean;
      readonly restaurantId: string;
      readonly label: {
        readonly __typename?: 'ProductLabel';
        readonly id: string;
        readonly name: string;
      } | null;
      readonly asset: { readonly __typename?: 'Asset'; readonly url: string };
      readonly dietaryProperties: ReadonlyArray<{
        readonly __typename?: 'DietaryProperty';
        readonly id: string;
        readonly name: Types.DietaryPropertyKind;
      }>;
      readonly ingredients: ReadonlyArray<{
        readonly __typename?: 'Ingredient';
        readonly id: string;
        readonly name: string;
      }>;
    }>;
  };
};

export const menuCollectionQueryMock: ExecutionResult<MenuCollectionQuery> = {
  data: {
    menuCollection: {
      id: 'e509e6ea-9fee-442a-9962-587ce7190430',
      color: 'Hello World',
      primaryImageUrl: 'Hello World',
      primaryTitle: 'Hello World',
      primaryDescription: 'Hello World',
      products: [
        {
          id: 'da7a7163-ba7e-4da9-ae8a-185e3da00a9a',
          slug: 'Hello World',
          name: 'Hello World',
          description: 'Hello World',
          calories: -48,
          cost: -2,
          outOfStock: false,
          restaurantId: '34319d08-060b-459a-a250-f9c4016b1bd6',
          label: {
            id: '34cb273b-7f9f-418d-830f-1b1f2c49f5fd',
            name: 'Hello World',
          },
          asset: { url: 'Hello World' },
          dietaryProperties: [
            { id: '994ccdca-b38b-4748-9afb-e88532ede7a1', name: 'DAIRY' },
            { id: 'daa933e0-e095-4a7b-88f0-bb560d0180d3', name: 'DAIRY' },
          ],
          ingredients: [
            { id: 'ca0c0520-a352-4a4a-a541-b5bc5d089f52', name: 'Hello World' },
            { id: 'e921d91b-fdfb-4abd-b8fd-f8eb150587b3', name: 'Hello World' },
          ],
        },
        {
          id: '84c48299-be51-41f9-b1e3-9b6d74afbe52',
          slug: 'Hello World',
          name: 'Hello World',
          description: 'Hello World',
          calories: 90,
          cost: 4,
          outOfStock: true,
          restaurantId: '3a6f32f0-edae-4f12-a810-af291521b27f',
          label: {
            id: '2badd9c8-f96f-4010-8a15-396429788b39',
            name: 'Hello World',
          },
          asset: { url: 'Hello World' },
          dietaryProperties: [
            { id: '138d5004-934e-4080-ad7f-d62514dd94f3', name: 'DAIRY' },
          ],
          ingredients: [
            { id: 'b41c23d4-c4b9-46ca-a862-2a517d3cbc3f', name: 'Hello World' },
            { id: '05167a35-8d45-41b9-b136-63db9eb2f517', name: 'Hello World' },
          ],
        },
      ],
    },
  },
};
export const MenuCollectionProductFragmentDoc = gql`
  fragment MenuCollectionProduct on Product {
    id
    slug
    name
    description
    calories
    cost
    outOfStock
    restaurantId
    label {
      id
      name
    }
    asset {
      url
    }
    dietaryProperties {
      id
      name
    }
    ingredients {
      id
      name
    }
  }
`;
export const MenuCollectionDocument = gql`
  query MenuCollection($collectionId: ID!) {
    menuCollection(id: $collectionId) {
      id
      color
      primaryImageUrl
      primaryTitle
      primaryDescription
      products {
        ...MenuCollectionProduct
      }
    }
  }
  ${MenuCollectionProductFragmentDoc}
`;

export function useMenuCollectionQuery(
  options: Omit<Urql.UseQueryArgs<MenuCollectionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<MenuCollectionQuery, MenuCollectionQueryVariables>({
    query: MenuCollectionDocument,
    ...options,
  });
}
